module.exports = __webpack_public_path__ + "static/img/sbklogo1.1761547470324.png";